// extracted by mini-css-extract-plugin
export default {"scc__footer":"Footer_scc__footer__AOOq3","scc__footer__title":"Footer_scc__footer__title__jqcAY","scc__footer__link":"Footer_scc__footer__link__Czs4z"};